import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { youtubeEmbedUrl } from '@utils/youtube';

export interface LightboxData {
  type: 'image' | 'video';
  /** Image source URL (for type 'image'). */
  url?: string;
  /** YouTube video id (for type 'video'). */
  youtubeId?: string;
  caption?: string;
}

@Component({
  selector: 'app-lightbox',
  templateUrl: './lightbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
})
export class LightboxComponent {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly dialogRef = inject(MatDialogRef<LightboxComponent>);
  readonly data = inject<LightboxData>(MAT_DIALOG_DATA);

  readonly embedUrl = computed<SafeResourceUrl | null>(() =>
    this.data.type === 'video' && this.data.youtubeId
      ? this.sanitizer.bypassSecurityTrustResourceUrl(youtubeEmbedUrl(this.data.youtubeId, true))
      : null,
  );

  close(): void {
    this.dialogRef.close();
  }
}
